import { AlertDialog } from '@zorro/design-system/v2/Dialog';
import { useMonolithMutation } from '@zorro/web/ui-utils';

type Props = {
  isOpen: boolean;
  employerId: string;
  employerName: string;
  onClose: () => void;
};

export const CancelInviteDialog = ({
  isOpen,
  employerId,
  employerName,
  onClose,
}: Props) => {
  const { tryMutate: cancelEmployerInvite, isPending } = useMonolithMutation({
    method: 'employersControllerCancelInviteEmployerAdmin',
    successMessage: 'Employer invitation cancelled',
  });

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      variant="negative"
      title="Cancel Invitation?"
      description={`Are you sure you want to cancel the invitation to ${employerName}? They won't be able to use the link you shared`}
      primaryLabel="Cancel invitation"
      onPrimaryAction={() => cancelEmployerInvite([employerId]).map(onClose)}
      isPrimaryLoading={isPending}
      secondaryLabel="Don't cancel"
      onSecondaryAction={onClose}
    />
  );
};
